module.exports = __webpack_public_path__ + "img/linen.76992756.jpg";